import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/PreAdvise/PreAdviseHome.css';
import historypic from '../../../Assets/TruckVisits/Assets/history.svg';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
class PreAdviseHome extends Component {
    constructor(props) {
        super(props)
        this.state = {
            preadvisedata: [
                { id: 1, heading: "Create Pre-advise for Single Container", history: "Track History", ContainerPath: "/CreatePreadvise", HistoryPath: "/PreAdvise" },
                { id: 2, heading: "Create Pre-advise for Multiple Container", history: "Track History", ContainerPath: "/UploadPreadviseDocument", HistoryPath: "/TrackMultipleContainer" },
                { id: 3, heading: "Submit Pre-advise Proxy", history: "Track History", ContainerPath: "/PreadviseProxy", HistoryPath: "/TrackHistoryforProxy" }]
        }
    }
    handleContainer = event => {
        this.state.preadvisedata?.find((preadvisedata11) => {
            if (preadvisedata11?.id === event + 1) {
                this.props.history.push(preadvisedata11?.ContainerPath)
            }
        })
    }
    handleContainerHistory = event => {
        this.state.preadvisedata?.find((preadvisedata11) => {
            if (preadvisedata11?.id === event + 1) {
                this.props.history.push(preadvisedata11?.HistoryPath)
            }
        }) 
    }
    render() {
        return (
            <div class="csoutercolor444">
                <MetaDecorator title={TitleDescription.preAdviseHomePageTitle} description={TitleDescription.preAdviseHomePageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofull444">
                    <div id="csnobox1444">
                        <nav class="ccnononavbar444">
                            <div className="ccnonavbarname444">
                                <small id="nonavc444"> Pre-advise</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="notificationmaincard444">
                            {(this.state.preadvisedata?.map((preadvisedata11, index) => {
                                return (
                                    <div class="consdiv1pre444">
                                        <div class="consdiv2444" >
                                            <div class="containsboth" onClick={() => this.handleContainer(index)}>
                                                <div class="thirdleftsideouter">
                                                    <div class="consdiv3444">
                                                        <small id="headingvalue">{preadvisedata11?.heading}</small>
                                                    </div>
                                                </div>
                                                <div class="rightsidearrowouter">
                                                    <img src={rightarrow} id="rightarrowsurprise" height="16" width="16" class="" alt="" loading="lazy" />
                                                </div>
                                            </div>
                                            <div class="rightouterr1" onClick={() => this.handleContainerHistory(index)}>
                                                <div class="rightimgdiv">
                                                    <img src={historypic} id="rightwatchimg" height="18" width="18" class="" alt="" loading="lazy" />
                                                </div>
                                                <div class="trackhistorydivhomeh">
                                                    <small id="redtrackhistory">{preadvisedata11?.history}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>);
                            }))}
                        </div>
                    </div>
                </div>
                <div class="notifooter01">
                    <Footer />
                </div>
                <div class="notifooter02">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default PreAdviseHome;